import { render, staticRenderFns } from "./Send-Review.vue?vue&type=template&id=34409d20"
import script from "./Send-Review.vue?vue&type=script&lang=js"
export * from "./Send-Review.vue?vue&type=script&lang=js"
import style0 from "./Send-Review.vue?vue&type=style&index=0&id=34409d20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports